import { Flex, Icon, Text } from "@chakra-ui/react"
import React from "react"
import { MdChevronRight } from "react-icons/md"
import { RiShoppingCart2Line } from "react-icons/ri"
import { useDispatch } from "react-redux"
import { interactionResponse } from "~/services/webvitals/defer"
import { actions } from "~/redux/process"
import { RemoteStoreApi } from "./RemoteStoreTypes"
import { useTranslation } from "react-i18next"

interface Props {
  store: RemoteStoreApi
  isStoreActive: boolean
}

const StoreBuyFromButton: React.FC<Props> = ({ store, isStoreActive }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const onOrderFromStore = async () => {
    await interactionResponse()

    dispatch(
      actions.orderFromStore({
        storeId: store.id,
        storeLat: store.latitude,
        storeLng: store.longitude,
        storePlace: `${store.city}, ${store.address1} ${store.postCode}`,
      })
    )
  }

  return (
    <Flex
      id="store-order"
      borderWidth={2}
      borderColor={isStoreActive ? "primary.500" : "gray.300"}
      borderRadius="md"
      p={3}
      alignItems="center"
      gap={4}
      width="240px"
      _hover={{
        cursor: isStoreActive ? "pointer" : "not-allowed",
      }}
      onClick={isStoreActive ? onOrderFromStore : undefined}
    >
      <Flex>
        <Icon
          as={RiShoppingCart2Line}
          color={isStoreActive ? "primary.600" : "gray.300"}
          boxSize="40px"
        />
      </Flex>
      <Flex flexDirection="column" gap={1}>
        <Flex alignItems="center" gap={2}>
          <Text
            fontWeight="bold"
            color={isStoreActive ? "gray.600" : "gray.400"}
          >
            {t(`components.store.StoreBuydFromButton.title`)}
          </Text>
          <Icon
            as={MdChevronRight}
            boxSize="22px"
            color={isStoreActive ? "gray.600" : "gray.400"}
          />
        </Flex>
        {isStoreActive ? (
          <Flex fontSize="small">
            {t("components.store.StoreBuydFromButton.active.description")}
          </Flex>
        ) : (
          <Flex
            fontSize="small"
            color={isStoreActive ? "gray.600" : "gray.400"}
          >
            {t("components.store.StoreBuydFromButton.inactive.description")}
          </Flex>
        )}
      </Flex>
    </Flex>
  )
}

export default StoreBuyFromButton
